// extracted by mini-css-extract-plugin
module.exports = {"form":"DevLogin_form__wV8X1","info":"DevLogin_info__3Mc-w"};